import { StateSelectionWidget } from "components/FormWidget";

const uiSchema = () => ({
  state_id: {
    "ui:widget": StateSelectionWidget,
  },
});

export default uiSchema;
